export const TEST_ID = 'helpIcon';
